import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, ShoppingCart, ClipboardList, User, Menu, X, Coffee, Award, PartyPopper, Camera, Globe, Users, LogOut } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
const MobileNavbar: React.FC = () => {
  const {
    totalItems
  } = useCart();
  const {
    logout
  } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleLogout = () => {
    logout();
    navigate('/login');
    setMenuOpen(false);
  };
  // Determine active tab
  const isActive = (paths: string[]) => {
    return paths.some(path => location.pathname === path || location.pathname.startsWith(path + '/'));
  };
  return <>
      {/* Top header */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 z-20" data-id="element-67">
        <div className="flex items-center" data-id="element-68">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgVxQ9YUevUSGke2gMG7SZ/logo.png" alt="Just Cheetah" className="h-8" onClick={() => navigate('/')} data-id="element-69" />
        </div>
        <button onClick={toggleMenu} className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#E84118]" aria-label={menuOpen ? 'Close menu' : 'Open menu'} data-id="element-70">
          {menuOpen ? <X size={24} className="text-gray-700" data-id="element-71" /> : <Menu size={24} className="text-gray-700" data-id="element-72" />}
        </button>
      </div>
      {/* Mobile menu overlay */}
      {menuOpen && <div className="md:hidden fixed inset-0 bg-gray-800 bg-opacity-75 z-10" onClick={toggleMenu} data-id="element-73">
          <div className="fixed right-0 top-0 h-full w-64 bg-white shadow-xl p-4 pt-20 z-20 overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-74">
            <div className="space-y-1" data-id="element-75">
              <p className="px-3 text-xs text-gray-500 uppercase tracking-wider mt-4 mb-2" data-id="element-76">
                Order Food
              </p>
              <NavLink to="/" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-77">
                <Home size={20} className="mr-3" data-id="element-78" />
                <span data-id="element-79">Home</span>
              </NavLink>
              <NavLink to="/food" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-80">
                <Coffee size={20} className="mr-3" data-id="element-81" />
                <span data-id="element-82">Menu</span>
              </NavLink>
              <NavLink to="/cart" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md relative ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-83">
                <ShoppingCart size={20} className="mr-3" data-id="element-84" />
                <span data-id="element-85">Cart</span>
                {totalItems > 0 && <span className="ml-2 bg-[#E84118] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-86">
                    {totalItems}
                  </span>}
              </NavLink>
              <NavLink to="/order/history" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-87">
                <ClipboardList size={20} className="mr-3" data-id="element-88" />
                <span data-id="element-89">Orders</span>
              </NavLink>
              <p className="px-3 text-xs text-gray-500 uppercase tracking-wider mt-4 mb-2" data-id="element-90">
                Social & Events
              </p>
              <NavLink to="/mystery-lunch" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-91">
                <Users size={20} className="mr-3" data-id="element-92" />
                <span data-id="element-93">Mystery Lunch</span>
              </NavLink>
              <NavLink to="/foodie-challenge" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-94">
                <Camera size={20} className="mr-3" data-id="element-95" />
                <span data-id="element-96">Foodie Challenge</span>
              </NavLink>
              <NavLink to="/themed-lunches" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-97">
                <Globe size={20} className="mr-3" data-id="element-98" />
                <span data-id="element-99">Themed Lunches</span>
              </NavLink>
              <NavLink to="/party-planner" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-100">
                <PartyPopper size={20} className="mr-3" data-id="element-101" />
                <span data-id="element-102">Party Planner</span>
              </NavLink>
              <NavLink to="/community" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-103">
                <Globe size={20} className="mr-3" data-id="element-104" />
                <span data-id="element-105">Community</span>
              </NavLink>
              <NavLink to="/food-passport" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-106">
                <Award size={20} className="mr-3" data-id="element-107" />
                <span data-id="element-108">Food Passport</span>
              </NavLink>
              <NavLink to="/profile" className={({
            isActive
          }) => `flex items-center px-3 py-3 rounded-md ${isActive ? 'bg-gray-100 text-[#E84118]' : 'text-gray-700 hover:bg-gray-50'}`} onClick={toggleMenu} data-id="element-109">
                <User size={20} className="mr-3" data-id="element-110" />
                <span data-id="element-111">Profile</span>
              </NavLink>
              <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-112">
                <button onClick={handleLogout} className="flex w-full items-center px-3 py-3 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-113">
                  <LogOut size={20} className="mr-3" data-id="element-114" />
                  <span data-id="element-115">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Bottom navigation bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center h-16 z-10" data-id="element-116">
        <NavLink to="/" className={`flex flex-col items-center justify-center w-1/4 h-full ${isActive(['/']) ? 'text-[#E84118]' : 'text-gray-600'}`} data-id="element-117">
          <Home size={20} data-id="element-118" />
          <span className="text-xs mt-1" data-id="element-119">Home</span>
        </NavLink>
        <NavLink to="/cart" className={`flex flex-col items-center justify-center w-1/4 h-full relative ${isActive(['/cart', '/checkout']) ? 'text-[#E84118]' : 'text-gray-600'}`} data-id="element-120">
          <ShoppingCart size={20} data-id="element-121" />
          {totalItems > 0 && <span className="absolute top-1 right-6 bg-[#E84118] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-122">
              {totalItems}
            </span>}
          <span className="text-xs mt-1" data-id="element-123">Cart</span>
        </NavLink>
        <NavLink to="/order/history" className={`flex flex-col items-center justify-center w-1/4 h-full ${isActive(['/order']) ? 'text-[#E84118]' : 'text-gray-600'}`} data-id="element-124">
          <ClipboardList size={20} data-id="element-125" />
          <span className="text-xs mt-1" data-id="element-126">Orders</span>
        </NavLink>
        <NavLink to="/profile" className={`flex flex-col items-center justify-center w-1/4 h-full ${isActive(['/profile', '/food-passport']) ? 'text-[#E84118]' : 'text-gray-600'}`} data-id="element-127">
          <User size={20} data-id="element-128" />
          <span className="text-xs mt-1" data-id="element-129">Profile</span>
        </NavLink>
      </div>
    </>;
};
export default MobileNavbar;